import { COLUMN_TYPES } from './utils/enums';

export class AuTableRootComponent {
	columns: string[] = [];
	head: string[] = [];
	tableActions = new Map();

	COLUMN_TYPES = COLUMN_TYPES;

	constructor() {}
}
